/* eslint-disable no-console */
import { createStore, compose, applyMiddleware } from 'redux';
import reduxImmutableStateInvariant from 'redux-immutable-state-invariant';
import thunk from 'redux-thunk';

import { routerMiddleware } from 'react-router-redux'; 
import * as Sentry from '@sentry/browser'

import history from './history'
import rootReducer from '../redux';
import chatsSocketMiddleware from '../redux/chats_details/middleware';
import memberSocketMiddleware from '../redux/member_details/middleware';


const crashReporterMiddleware = store => next => action => {
  try {
    return next(action)
  } catch (error) {
    console.error('SENTRY: Caught an exception! -', error)
    Sentry.withScope(scope => {
      scope.setExtras({ action, state: store.getState() })
      Sentry.captureException(error)
    })
    throw error
  }
}

function configureStoreProd(initialState) {
    const reactRouterMiddleware = routerMiddleware(history);
    const middlewares = [
        // Add other middleware on this line...
        // thunk middleware can also accept an extra argument to be passed to each thunk action
        // https://github.com/gaearon/redux-thunk#injecting-a-custom-argument

        thunk,
        reactRouterMiddleware,
        crashReporterMiddleware,
        chatsSocketMiddleware,
        memberSocketMiddleware,
    ];
    return createStore(rootReducer, initialState, compose(applyMiddleware(...middlewares)));
}

function configureStoreDev(initialState) {
    const reactRouterMiddleware = routerMiddleware(history);
    const middlewares = [
        // Add other middleware on this line...
        // Redux middleware that spits an error on you when you try to mutate your state either inside a dispatch or between dispatches.
        reduxImmutableStateInvariant({
            ignore: [
                'dashboard_details.socket_details.socket',
                'usage_details.socket_details.socket',
                'filter_details.filters',
            ]
        }),
        // thunk middleware can also accept an extra argument to be passed to each thunk action
        // https://github.com/gaearon/redux-thunk#injecting-a-custom-argument

        thunk,
        reactRouterMiddleware,
        crashReporterMiddleware,
        chatsSocketMiddleware,
        memberSocketMiddleware
    ];
    const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose; // add support for Redux dev tools
    const store = createStore(rootReducer, initialState, composeEnhancers(applyMiddleware(...middlewares)));

    if (module.hot) {
        // Enable Webpack hot module replacement for reducers
        module.hot.accept('../redux', () => {
            const nextReducer = require('../redux').default; // eslint-disable-line global-require
            store.replaceReducer(nextReducer);
        });
    }
    return store;
}

const configureStore = process.env.NODE_ENV === 'production' ? configureStoreProd : configureStoreDev;

export default configureStore;



// WEBPACK FOOTER //
// ./src/data/store/configureStore.js